import { useEffect, useRef, useState } from "react";

function AutoShrinkText({ children, maxFont = 16, minFont = 12 }) {
    const ref = useRef(null);
    const [fontSize, setFontSize] = useState(maxFont);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        // Reset font size to max before checking
        setFontSize(maxFont);

        const adjustFont = () => {
            let size = maxFont;
            while (
                el.scrollWidth > el.clientWidth &&
                size > minFont
            ) {
                size -= 1;
                setFontSize(size);
            }
        };

        // Delay to ensure DOM is rendered
        setTimeout(adjustFont, 0);
    }, [children, maxFont, minFont]);

    return (
        <span
            ref={ref}
            style={{
                fontSize: fontSize,
                display: "block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "80vw"
            }}
        >
            {children}
        </span>
    );
}

export default AutoShrinkText;
